"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = tokensActionsHandlers;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _effects = require("redux-saga/effects");

var _actions = require("../../actions");

var _actionType = require("../../actionType");

var _config = require("../../config");

var _config2 = _interopRequireDefault(require("../config"));

var _RefreshTokensTimeout = _interopRequireDefault(require("./RefreshTokensTimeout"));

var _storageHandlers = require("./storageHandlers");

var _utilities = require("./utilities");

var _marked =
/*#__PURE__*/
_regenerator.default.mark(handleTimeoutChannel),
    _marked2 =
/*#__PURE__*/
_regenerator.default.mark(cancelTimeoutChannnelTask),
    _marked3 =
/*#__PURE__*/
_regenerator.default.mark(clearTokensHandler),
    _marked4 =
/*#__PURE__*/
_regenerator.default.mark(setTokensHandler),
    _marked5 =
/*#__PURE__*/
_regenerator.default.mark(tokensActionsHandlers);

function handleTimeoutChannel(timeoutChannel) {
  return _regenerator.default.wrap(function handleTimeoutChannel$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          if (!true) {
            _context.next = 7;
            break;
          }

          _context.next = 3;
          return (0, _effects.take)(timeoutChannel);

        case 3:
          _context.next = 5;
          return (0, _effects.put)((0, _actions.refreshTokens)());

        case 5:
          _context.next = 0;
          break;

        case 7:
        case "end":
          return _context.stop();
      }
    }
  }, _marked, this);
}

var timeoutChannelTask = null;

function cancelTimeoutChannnelTask() {
  return _regenerator.default.wrap(function cancelTimeoutChannnelTask$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          if (!timeoutChannelTask) {
            _context2.next = 4;
            break;
          }

          _context2.next = 3;
          return (0, _effects.cancel)(timeoutChannelTask);

        case 3:
          timeoutChannelTask = null;

        case 4:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2, this);
}

function clearTokensHandler(refreshTokensTimeout) {
  return _regenerator.default.wrap(function clearTokensHandler$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          refreshTokensTimeout.clearTimeout();
          _context3.next = 3;
          return (0, _storageHandlers.clearTokens)();

        case 3:
          _context3.next = 5;
          return cancelTimeoutChannnelTask();

        case 5:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked3, this);
}

function clearLocaleStorageTokens() {
  // Previously tokens were stored in locale storage,
  // instead of IndexedDB as it it now.
  // So we need to delete them.
  window.localStorage.removeItem('tokens');
}

function setTokensHandler(_ref, refreshTokensTimeout) {
  var tokens, min, minRequired, cantSet, channel;
  return _regenerator.default.wrap(function setTokensHandler$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          tokens = _ref.tokens;
          clearLocaleStorageTokens(); // store tokens to a local storage

          _context4.next = 4;
          return (0, _storageHandlers.storeTokens)(tokens);

        case 4:
          if (!(0, _utilities.hasExpirationProperty)(tokens)) {
            _context4.next = 19;
            break;
          }

          if (refreshTokensTimeout.validateExpiration(tokens)) {
            _context4.next = 11;
            break;
          }

          min = _config2.default.options.tokens.minRequiredExpiration;
          minRequired = "Minimal required access token expiration is ".concat(min, "ms (at ").concat(new Date(Date.now() + min), ").");
          cantSet = "Access token expiration at ".concat(tokens.accessToken.expiration, " it too low.");

          _config.logger.warn("".concat(minRequired, "\n").concat(cantSet));

          return _context4.abrupt("return");

        case 11:
          _context4.next = 13;
          return cancelTimeoutChannnelTask();

        case 13:
          // create new timeout for refreshing tokens
          channel = refreshTokensTimeout.setTimeout(tokens); // and wait for token to expire

          _context4.next = 16;
          return (0, _effects.fork)(handleTimeoutChannel, channel);

        case 16:
          timeoutChannelTask = _context4.sent;
          _context4.next = 21;
          break;

        case 19:
          _context4.next = 21;
          return cancelTimeoutChannnelTask();

        case 21:
        case "end":
          return _context4.stop();
      }
    }
  }, _marked4, this);
}

function tokensActionsHandlers() {
  var _config$options$token, requestDurationEstimate, minRequiredExpiration, refreshTokensTimeout;

  return _regenerator.default.wrap(function tokensActionsHandlers$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          _config$options$token = _config2.default.options.tokens, requestDurationEstimate = _config$options$token.requestDurationEstimate, minRequiredExpiration = _config$options$token.minRequiredExpiration;
          refreshTokensTimeout = new _RefreshTokensTimeout.default({
            requestDurationEstimate: requestDurationEstimate,
            minRequiredExpiration: minRequiredExpiration
          });
          _context6.next = 4;
          return (0, _effects.all)([(0, _effects.takeEvery)(_actionType.SET_AUTH_TOKENS,
          /*#__PURE__*/
          _regenerator.default.mark(function setAuthTokens(action) {
            return _regenerator.default.wrap(function setAuthTokens$(_context5) {
              while (1) {
                switch (_context5.prev = _context5.next) {
                  case 0:
                    _context5.next = 2;
                    return (0, _effects.race)({
                      task: setTokensHandler(action, refreshTokensTimeout),
                      abort: (0, _effects.take)(_actionType.AUTH_LOGOUT)
                    });

                  case 2:
                  case "end":
                    return _context5.stop();
                }
              }
            }, setAuthTokens, this);
          })), (0, _effects.takeEvery)(_actionType.AUTH_LOGOUT, clearTokensHandler, refreshTokensTimeout)]);

        case 4:
        case "end":
          return _context6.stop();
      }
    }
  }, _marked5, this);
}